import OtpIvrSelect from './OtpIvrSelectContainer';

export default  OtpIvrSelect;